/*
 * Copyright © 2018, Rezo Zero
 *
 * @file Bubble.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import AObject from '../abstracts/AObject'
import { TweenMax } from 'gsap'

export default class Bubble extends AObject {
    constructor (id) {
        super()

        this.active = false
        this.id = id
        this.type = id % 2
        // this.x = 0
        // this.y = 0
        // this.targetX = 0
        // this.targetY = 0
        this.radius = 0
        this.targetRadius = 0
        this.color = 0
        this.initialColor = 0
        this.opacity = 0
        this.colors = {
            white: {
                r: 255,
                g: 255,
                b: 255
            },
            red: {
                r: 213,
                g: 162,
                b: 192
            },
            purple: {
                r: 186,
                g: 199,
                b: 235
            }
        }
    }

    setup (p5) {
        this.x = p5.random(p5.width / 2) + p5.round(this.type) * p5.width / 2
        this.y = p5.random(p5.height)
        this.targetX = this.x
        this.targetY = this.y
        this.targetRadius = p5.random(200) + 300
        this.color = this.type < 0.5 ? { ...this.colors.red } : { ...this.colors.purple }
        this.initialColor = { ...this.color }
        this.opacity = this.randomOpacity(p5)
        this.initialOpacity = this.opacity
    }

    randomOpacity (p5) {
        return p5.floor((p5.random(0.5) + 0.5) * 100) / 100
    }

    draw (p5) {
        if (!this.active) return

        p5.push()
        p5.translate(this.x, this.y)
        let rgba = `rgba(${p5.floor(this.color.r)}, ${p5.floor(this.color.g)}, ${p5.floor(this.color.b)}, ${this.opacity})`
        p5.fill(rgba)
        this.radius += (this.targetRadius - this.radius) / 20
        p5.ellipse(0, 0, this.radius)
        p5.pop()

        this.targetX += p5.random(-10, 10) + p5.cos(p5.frameCount / 200) * 0.1
        this.targetY += p5.random(-10, 10) + p5.cos(-p5.frameCount / 200) * 0.1

        this.targetX = p5.min(p5.max(this.targetX, 0), p5.width)
        this.targetY = p5.min(p5.max(this.targetY, 0), p5.height)

        this.x += (this.targetX - this.x) / 200
        this.y += (this.targetY - this.y) / 200
    }

    changeColor (newColorValue, duration = 2) {
        let newColor = newColorValue

        if (typeof newColorValue === 'string') {
            newColor = this.colors[newColorValue]
        }

        TweenMax.to(this.color, duration, {
            r: newColor.r,
            g: newColor.g,
            b: newColor.b
        })
    }

    changeOpacity (newOpacity, duration = 1) {
        TweenMax.to(this, duration, {
            opacity: newOpacity
        })
    }
}



// WEBPACK FOOTER //
// ./webpack/js/bubbles/Bubble.js